import { useSelector } from 'react-redux';

import { mobileSideSelector } from '../../../selectors';
import { EHostType } from '../../../types/hostType';
import { EMobileLayoutActiveSide } from '../../../types/mobileSide';
import { useApplicationContext } from '../../../utils/applicationContext';
import { isWebView } from '../../../utils/isWebView';

/**
 * Возвращает признак видимости нижней навигации мобвеба: только в списке чатов, не во frame и webview
 */
export const useIsBottomNavigationVisible = (): boolean => {
  const {
    config,
    custom: { hostType },
  } = useApplicationContext();
  const mobileSide = useSelector(mobileSideSelector);

  const isFrame = hostType === EHostType.Frame;
  const isWebview = isWebView(config);

  return !isFrame && !isWebview && mobileSide === EMobileLayoutActiveSide.Left;
};
